
<template>
  <el-container class="downloadIndex">
    <el-header>
      <img
        class="logo"
        src="../assets/logo.svg">
      <p>{{$t('global.parentTitle')}}</p>
    </el-header>
      <el-main>
          <p>{{$t('tabBar.download')}}</p>
          <div class="flex_justify_center">
            <!--          <img @click="utils.toAppStore()" src="../../assets/Download_App_Store.svg" style="margin-right: 20px;" />-->
            <!--          <img @click="utils.toGooglePlay()" src="../../assets/google-play-badge.png" />-->
            <img src="../assets/Download_App_Store.svg" style="margin-right: 20px;" />
            <img style="width: 120px;height: 40px" src="../assets/tencent.png" />
          </div>
      </el-main>
  </el-container>
</template>
<script>
import IndexHeader from './views/header'
export default {
  components: {
    IndexHeader
  }
}
</script>
<style lang="less" scoped>
#app{
  height: 100%;
}
  .downloadIndex{
    width: 100vw;
    height:100vh!important;
    margin: 0 auto;
    background: #fff;
  }
  .el-header{
      width: 100vw;
      height:auto!important;
      padding: 20px 0 10px 20px;
      font-family: Sofia Pro-Regular;
      font-size: 20px;
      font-weight: 400;
      text-align: left;
      color: #353643;
      .logo {
        height: 40px;
        img{
          width:100%;
          height:100%;
        }
      }
      p {
          width: 175px;
          margin-top: 5px;
          text-align: center;
          font-size: 14px;
      }
  }
  .el-main{
    overflow: inherit;
    padding:0;
    height:50vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content:center;
    background: #fff;
    z-index: 2147483005;
    p{
      width:80vw;
      margin:0 auto;
      font-size: 20px;
      font-family: Sofia Pro-Regular;
      color: #424347;
      margin-bottom: 20px;
      text-align: center;
    }
    .flex_justify_center{
      margin-bottom:60px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/download.vue